import { DefaultBankAccountList, DefaultBankAccountRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchDefaultBankAccount() {
  const api = useApi();
  // Same union as useFetchBankAccounts, and for the same reason: a consumer that keeps a skeleton up
  // until the defaults are known has to tell "not fetched yet" from "fetched and empty", which a
  // fetching boolean cannot — both are false.
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [defaultOperationalBankAccount, setDefaultOperationalBankAccount] = useState<DefaultBankAccountList[]>([]);
  const [defaultBillingBankAccount, setDefaultBillingBankAccount] = useState<DefaultBankAccountList[]>([]);

  // PortalUser omitted: no earthnode handler for this endpoint reads it (verified against
  // lib/www/routes/v2/bank_account.php) — the backend takes the user from the JWT.
  async function fetchDefaultBankAccount(params: Omit<DefaultBankAccountRequest, 'PortalUser'>) {
    try {
      setStatus('loading');
      const res = await api.fetchDefaultBankAccount(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setDefaultOperationalBankAccount(res.DefaultOperationalBankAccount);
      setDefaultBillingBankAccount(res.DefaultBillingBankAccount);
      setStatus('success');

      return res;
    } catch (error) {
      setStatus('error');
      console.error(error);
      throw error;
    }
  }

  return { status, defaultOperationalBankAccount, defaultBillingBankAccount, fetchDefaultBankAccount };
}
